

const Footer = () => {
    return (
        <footer className="fai-footer text-center py-7 bg-[#1d4aa7] shadow-xl">
            <ul className="flex content-center w-100 justify-center pb-5">
                <li className="">Home</li>
                <li className="">Contato</li>
                <li className=""><a href="/admin"> Admin </a></li>
            </ul>
            <p>© 2024 - All rights reserved</p>
        </footer>
    );
}

export default Footer